export default __webpack_public_path__ + "static/media/hdr-low.1ef4be52.png";